var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_vm._t("bot-avatar"),_c('div',{staticClass:"content",class:{ 'my-message': _vm.isMyMessage },domProps:{"innerHTML":_vm._s(_vm.message.message)}}),_vm._t("sender-avatar")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }